import { PARSE_HARMONY_TITLE, PARSE_HARMONY_PRICING } from './actionTypes';
import titleParser from '../utils/seo/titleParser';

export const updateHarmonytitle = () => (dispatch, getState) => {
    const { pricing, gallery, configurator, config } = getState();
    const { options, choices } = configurator;


      const { isSpecialBuy, originalPrice, specialPrice } = pricing;
      const specialBuy = isSpecialBuy ? "Special Buy" : null;
      const discount = originalPrice - specialPrice;
      const percent = ( discount / originalPrice ) * 100;
      const propProductData = {
        pricing: {
          unitOfMeasure: "each",
          value: specialPrice,
          original: originalPrice,
          promotion: {
            dollarOff: discount,
            percentageOff: percent,
            savingsCenter: specialBuy,
            type: "DISCOUNT",
          },
        }
      };
          
    const harmonyTitle = titleParser(config.dynamicPageTitle, options, choices);
    
    return dispatch({
        type: PARSE_HARMONY_TITLE,
        harmonyTitle,
      });

  };

  export const updateHarmonyPrice = () => (dispatch, getState) => {
    const { pricing, configurator, config } = getState();
    const { options, choices } = configurator;



    
      const { isSpecialBuy, originalPrice, specialPrice } = pricing;
      const specialBuy = isSpecialBuy ? "Special Buy" : null;
      const discount = originalPrice - specialPrice;
      const percent = ( discount / originalPrice ) * 100;
      const propProductData = {
        pricing: {
          unitOfMeasure: "each",
          value: specialPrice,
          original: originalPrice,
          promotion: {
            dollarOff: discount,
            percentageOff: percent,
            savingsCenter: specialBuy,
            type: "DISCOUNT",
          },
        }
      };
          
    
    return dispatch({
        type: PARSE_HARMONY_PRICING,
        harmonyPricing: propProductData,
      });

  };
